var _path, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLockGroup(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 11,
    height: 14,
    viewBox: "0 0 11 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.4395 7.95726C10.4395 7.25504 9.87099 6.68654 9.17025 6.688H8.79481L8.79343 3.69523C8.79184 1.65686 7.13359 -0.00135631 5.09521 8.32459e-07C3.05695 0.00148522 1.39999 1.65984 1.39999 3.69822L1.40147 6.69126H1.26925C0.568534 6.69274 0 7.26126 0 7.96198L0.00307478 12.411C0.00307478 13.1117 0.571582 13.6802 1.27233 13.6802L9.17334 13.6757C9.87406 13.6757 10.4426 13.1072 10.4426 12.4064L10.4395 7.95726ZM2.76513 6.69109L2.76365 3.69805C2.76216 2.41056 3.80938 1.36333 5.09527 1.36187C6.38276 1.36187 7.42999 2.4092 7.43146 3.69509L7.43305 6.68786L2.76513 6.69109Z",
    fill: "url(#paint0_linear_57_23516)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_57_23516",
    x1: 2,
    y1: -0.5,
    x2: 11,
    y2: 15.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C0A828"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A28D1D"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLockGroup);
export default __webpack_public_path__ + "static/media/lock-group.e2b3449b1237bc6f9ed9fb1920be081f.svg";
export { ForwardRef as ReactComponent };